import { createRoot } from "react-dom/client";
import { LarpSimulator } from "../components/LarpSimulator";
import "../app/globals.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Missing #root element");
}

createRoot(root).render(<LarpSimulator />);
